/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Laddar"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var svSE = Object.assign(TranslationProviderComponent, {
  translations
});

export { svSE as s };
//# sourceMappingURL=sv-SE-G2yy_UbB.js.map
